import { Box, useMediaQuery, useTheme } from "@mui/material";
import { Scene } from "react-scrollmagic";
import confetti from "canvas-confetti";

const RoadmapItem = ({
  title,
  content,
  duration = 300,
  mobileDuration = 200,
  isLast = false,
}: {
  title: string;
  content: string;
  duration: number | string;
  mobileDuration: number | string;
  isLast?: boolean;
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:450px)");

  return (
    <div className="timeline-container">
      {!isMobile && (
        <div className="timeline-left">
          <div className="timeline_date-container">
            <Scene duration={duration} pin={true}>
              {(progress: number) => {
                return (
                  <div className="timeline_date-wrapper">
                    <img
                      src="https://assets-global.website-files.com/614783969f1040a8edff849c/614a298b3a4739405e06e942_timeline-dot.svg"
                      loading="lazy"
                      alt=""
                      className="timeline_dot"
                    ></img>
                    <p
                      className="date multi-line"
                      style={{
                        color:
                          progress < 1
                            ? "inherit"
                            : theme.palette.secondary.main,
                      }}
                    >
                      {title}
                    </p>
                  </div>
                );
              }}
            </Scene>
          </div>
        </div>
      )}
      <div className="timeline-right">
        <div className="timeline_event">
          <Scene
            duration={isMobile ? mobileDuration : duration}
            pin={false}
            reverse={false}
          >
            {(progress: number) => {
              if (isLast && progress >= 1) {
                confetti({
                  particleCount: 150,
                  spread: 60,
                });
              }
              return (
                <Box>
                  {isMobile && (
                    <h4
                      style={{
                        color:
                          progress < 1
                            ? "inherit"
                            : theme.palette.secondary.main,
                      }}
                    >
                      {title}
                    </h4>
                  )}
                  <p
                    style={{
                      margin: 0,
                    }}
                  >
                    {content}
                    <br />
                    <br />
                  </p>
                </Box>
              );
            }}
          </Scene>
        </div>
      </div>
    </div>
  );
};

export default RoadmapItem;
